import { FormInput } from "@/Components";
import CustomModal from "@/Components/Modal";
import { useAddCapabilities } from "@/hooks/capabilitiesHook";
import { JsonRecord } from "@/types";
import { useRetrieveTitle } from "@/Utils/helpers";
import { Form, FormInstance } from "antd";
import React, { useState } from "react";
import { toast } from "react-toastify";
import style from "./style.module.scss";

const CapabilityModel: React.FC<any> = ({ open, setOpen }) => {
  const [capabilityForm] = Form.useForm<FormInstance>();
  const { mutateAsync: createCapabilities, isPending } = useAddCapabilities();
  const { getTitle } = useRetrieveTitle();

  const [selectedLang, setSelectedLang] = useState<string>("en-us");
  const [getCapabilityFormValues, setCapabilityFormValues] =
    useState<JsonRecord>({});

  const handleCapabilitiesModal = async () => {
    const payload: any = { label: getCapabilityFormValues };
    try {
      const res = await createCapabilities(payload);
      if (res) {
        toast.success(getTitle("capability_created_successfully"));
        setCapabilityFormValues({});
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(getTitle("data_failed"));
      console.log(error);
    }
  };

  return (
    <CustomModal
      open={open}
      title={<h3>{getTitle("create_capabilities")}</h3>}
      handleCancel={() => {
        setOpen(false);
        capabilityForm.resetFields();
        setCapabilityFormValues({});
      }}
      handleOk={capabilityForm.submit}
      className={style.createConfigModal}
      confirmLoading={isPending}
      width={700}
      okText={getTitle("create")}
      cancelText={getTitle("cancel")}
    >
      <Form
        title="capabilities"
        form={capabilityForm}
        autoComplete="off"
        onFinish={handleCapabilitiesModal}
        onValuesChange={(values) =>
          setCapabilityFormValues({ ...getCapabilityFormValues, ...values })
        }
      >
        <div className={style.createCapabilityConatiner}>
          {selectedLang === "en-us" && (
            <Form.Item
              name="en-us"
              rules={[
                {
                  required: true,
                  message: getTitle("label_cannot_be_empty"),
                },
              ]}
            >
              <FormInput
                title={getTitle("capability")}
                placeholder={getTitle("enter_capability_name")}
                langBtn={true}
                setSelectedLang={setSelectedLang}
                selectedLang={selectedLang}
              />
            </Form.Item>
          )}
          {selectedLang === "ar-sa" && (
            <Form.Item
              name="ar-sa"
              rules={[
                {
                  required: true,
                  message: getTitle("label_cannot_be_empty"),
                },
              ]}
            >
              <FormInput
                title={getTitle("label")}
                placeholder={getTitle("enter_label")}
                langBtn={true}
                setSelectedLang={setSelectedLang}
                selectedLang={selectedLang}
              />
            </Form.Item>
          )}
        </div>
      </Form>
    </CustomModal>
  );
};

export default CapabilityModel;
